// extracted by mini-css-extract-plugin
export var cancelButton = "_mn-5";
export var content = "_mn-3";
export var createButton = "_mn-6";
export var drawerContainer = "_mn-0";
export var footer = "_mn-2";
export var header = "_mn-1";
export var orderFormColumn = "_mn-4";